import { useCollection, useDocument } from "../../hooks/useFirestore"
import { createManagedMutations } from "../../hooks/useManagedMutations"
import { AbsenceRequest, collectionName } from "./absenceRequest"

export function useAbsenceRequests({ opt_youngId }: { opt_youngId?: string }) {
   return useCollection<AbsenceRequest>({
      collectionName,
      suffixKey: [opt_youngId],
      transform: (query) => {
         if (opt_youngId) {
            return query.where("young_id").equals(opt_youngId)
         }

         return query
      },
   })
}

export function useAbsenceRequestsForYoung({ youngId }: { youngId?: string }) {
   return useCollection<AbsenceRequest>({
      enabled: !!youngId,
      collectionName,
      suffixKey: [youngId],
      transform: (query) => {
         return query.where("young_id").equals(youngId!)
      },
   })
}

export function useAbsenceRequest({ id }: { id: string }) {
   return useDocument<AbsenceRequest>(collectionName, id)
}

export const {
   useCreateManagedDocument: useCreateAbsenceRequest,
   useUpdateManagedDocument: useUpdateAbsenceRequest,
   useDeleteManagedDocument: useDeleteAbsenceRequest,
} = createManagedMutations<AbsenceRequest>(collectionName)
